import { cn } from '@dfh-corp-sites/ui/utils'
import React from 'react'

import TopSearchesList, { TopSearchesListProps } from './TopSearches'

export interface NoResultsProps {
  className?: string
  size?: TopSearchesListProps['size']
}

const NoResults: React.FC<NoResultsProps> = ({ size, className }) => (
  <div className={cn('flex flex-col items-center justify-center', className)}>
    <p className="text-gray-500 my-16 lg:my-28 text-2xl font-normal text-center text-balance">
      Oops! Looks like there’s nothing here.
    </p>

    <div className="w-full">
      <h2 className="text-brand-navy text-2xl font-bold pb-5 border-b border-brand-rule-grey mb-5">
        Try these top searches
      </h2>
      <TopSearchesList size={size} />
    </div>
  </div>
)

export default NoResults
